export default "__VITE_ASSET__ELparjP___"